import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export function PageFooterPagination({ page, totalPages, setPage }: { page: number; totalPages: number; setPage: (pg: number) => void }) {
  const safeTotalPages = Math.max(1, totalPages);
  const currentPage = Math.min(Math.max(page, 1), safeTotalPages);
  const numberOfPages = Array.from({ length: safeTotalPages }, (_, index) => index + 1);
  let arrOfCurrentPages = numberOfPages;

  if (currentPage >= 1 && currentPage < 3) {
    arrOfCurrentPages = numberOfPages.slice(0, 3);
  } else if (currentPage >= 3 && currentPage <= numberOfPages.length - 3) {
    arrOfCurrentPages = [currentPage - 1, currentPage, currentPage + 1];
  } else if (currentPage >= numberOfPages.length - 3) {
    arrOfCurrentPages = numberOfPages.slice(numberOfPages.length - 3);
  }

  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === safeTotalPages;

  return (
    <nav className='flex py-4 justify-center items-center rounded-lg' aria-label='Pagination'>
      <ul className='flex items-center gap-2'>
        <li>
          <button
            type='button'
            aria-label='Previous page'
            disabled={isFirstPage}
            onClick={() => setPage(currentPage - 1)}
            className='flex h-10 w-10 items-center justify-center rounded-full bg-white p-2 text-neutralColor-light transition duration-200 ease-in-out enabled:cursor-pointer enabled:hover:bg-primaryColor-normal enabled:hover:text-white disabled:cursor-not-allowed disabled:opacity-50'
          >
            <ChevronLeftIcon className='h-5 w-5' aria-hidden='true' />
          </button>
        </li>
        {arrOfCurrentPages.map((pg) => (
          <li key={pg}>
            <button
              type='button'
              aria-current={currentPage === pg ? 'page' : undefined}
              aria-label={`Page ${pg}`}
              onClick={() => setPage(pg)}
              className={`flex h-10 w-10 items-center justify-center rounded-full p-2 transition duration-200 ease-in-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryColor-normal ${
                currentPage === pg
                  ? 'bg-primaryColor-normal font-semibold text-white'
                  : 'bg-white text-neutralColor-dark hover:bg-primaryColor-medium hover:text-white cursor-pointer'
              }`}
            >
              {pg}
            </button>
          </li>
        ))}
        <li>
          <button
            type='button'
            aria-label='Next page'
            disabled={isLastPage}
            onClick={() => setPage(currentPage + 1)}
            className='flex h-10 w-10 items-center justify-center rounded-full bg-white p-2 text-neutralColor-light transition duration-200 ease-in-out enabled:cursor-pointer enabled:hover:bg-primaryColor-normal enabled:hover:text-white disabled:cursor-not-allowed disabled:opacity-50'
          >
            <ChevronRightIcon className='h-5 w-5' aria-hidden='true' />
          </button>
        </li>
      </ul>
    </nav>
  );
}
